export default __webpack_public_path__ + "static/media/404-not-found.e2aa3ba0.png";